<template>
    <div>
        <st-data-table
            :items="rows"
            :fields="fields"
            :actions="actions"
            :modelPresenter="presenter"
            @view="onView"
            responsive="sm"
            hover
        >
        </st-data-table>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { ComplainModel } from '@/modules/complain/complain-model';
    import { ComplainPermissions } from '@/modules/complain/complain-permissions';

    const { fields } = ComplainModel;

    export default {
        name: 'ComplainListTable',
        data() {
            return {
                presenter: ComplainModel.presenter,
                actions: [
                    {
                        name: 'view',
                        icon: 'eye',
                        tooltipText: 'Vizualizare',
                        customIcon: false,
                        type: 'primary'
                    },
                ],
            };
        },
        computed: {
            ...mapGetters({
                rows: 'complain/list/rows',
                currentUser: 'auth/currentUser',
            }),
            fields() {
                if (this.hasPermissionToStaffComplains) {
                    return this.staffTableFields;
                }
                return this.tableFields;
            },
            tableFields() {
                return [
                    fields.reporting_user_full_name,
                    fields.contact_user_full_name,
                    fields.identification_number,
                    fields.created_date,
                    fields.complain_type_id.extendField({ bold: true }),
                    fields.locality_name,
                    fields.status.extendField({ labelType: true }),
                ]
            },
            staffTableFields() {
                return [
                    fields.reporting_user_full_name,
                    fields.contact_user_full_name,
                    fields.identification_number,
                    fields.created_date.extendField({ bold: true }),
                    fields.locality_name,
                    fields.complain_type_name.extendField({ bold: true }),
                    fields.status.extendField({ labelType: true }),
                ]
            },
            hasPermissionToStaffComplains() {
                return new ComplainPermissions(this.currentUser).readStaff;
            },
        },
        methods: {
            onView(data) {
                if (!data?.item?.id) return;
                this.$router.push({
                    name: 'complainView',
                    params: {
                        id: data.item.id,
                    },
                });
            },
        },
    };
</script>

<style scoped>

</style>
